// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueWechatTitle from 'vue-wechat-title';
import Vuex from 'vuex';
import VueElementLoading from 'vue-element-loading'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'


Vue.use(VueWechatTitle);
Vue.use(ElementUI);
Vue.component('VueElementLoading', VueElementLoading);

Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.$http.defaults.baseURL = 'https://b.mysread.com/api6.php' //配置axios全局網絡請求的Url
Vue.prototype.$cryptoJS = CryptoJS;

/* eslint-disable no-new */
new Vue({
        el: '#app',
        router,
        components: { App },
        template: '<App/>'
})

export default () => {
        return new Vuex.Store({
                state: {},
                mutations: {}
        })
}

router.beforeEach((to, from, next) => {

        /* 路由發生變化修改頁面meta */
        if (to.meta.content) {
                const head = document.getElementsByTagName('head');
                const meta = document.createElement('meta');
                document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
                document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
                meta.content = to.meta.content;
                head[0].appendChild(meta)
        }

        /* 路由發生變化修改頁面title */
        if (to.meta.title) {
                document.title = to.meta.title;
        }
        next()
})



// WEBPACK FOOTER //
// ./src/main.js